import theme from '../theme'
import { makeStyles } from '@material-ui/core'

export const customClasses = makeStyles({
  root: {
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    borderColor: theme.palette.grey[500],
    borderRadius: theme.shape.borderRadius,
    padding: '5px',
    width: '100%',
    '&:hover': {
      borderColor: theme.palette.grey[800],
      borderRadius: theme.shape.borderRadius,
    },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius,
      outline: 'unset',
    },
    '&:active': {
      borderColor: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius,
    },
  },
})
